import React, { useEffect, useMemo, useContext } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { AuthContext } from "./../../components/login/AuthContext";
import { getJwtToken } from "../../utils/authUtils"; // ajuste le path si besoin

function normalizeLang(lng) {
  if (!lng) return null;
  const v = String(lng).toLowerCase();
  if (v.startsWith("fr")) return "fr";
  if (v.startsWith("en")) return "en";
  return null;
}

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const {
    userId,
    preferredLanguage,
    setPreferredLanguage,   // ✅ now available from context
    liveCsrfToken,
  } = useContext(AuthContext);

  const current = useMemo(() => normalizeLang(i18n.language) || "en", [i18n.language]);

  // ✅ 1) Sync i18n from AuthContext preferredLanguage (or i18nextLng)
  useEffect(() => {
    const pref = normalizeLang(preferredLanguage);
    const stored = normalizeLang(localStorage.getItem("i18nextLng"));
    const target = pref || stored || "en";

    if (normalizeLang(i18n.language) !== target) {
      i18n.changeLanguage(target);
    }
  }, [preferredLanguage, i18n]);

  // ✅ 2) Toggle + update context + persist server
  const switchLanguage = async () => {
    const prev = current;
    const next = prev === "en" ? "fr" : "en";

    // Optimistic UI + context
    setPreferredLanguage(next);
    await i18n.changeLanguage(next);
    localStorage.setItem("i18nextLng", next);

    // Persist to server if logged in
    if (!userId) return;

    try {
      const jwt = getJwtToken();

      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/user/preferences/language`,
        { preferredLanguage: next },
        {
          withCredentials: true,
          headers: {
            ...(liveCsrfToken ? { "x-csrf-token": liveCsrfToken } : {}),
            ...(jwt ? { Authorization: `Bearer ${jwt}` } : {}),
          },
        }
      );

      if (!res.data?.success) throw new Error("API returned success=false");
    } catch (e) {
      console.warn("Could not persist preferredLanguage server-side:", e?.message || e);

      // Rollback
      setPreferredLanguage(prev);
      await i18n.changeLanguage(prev);
      localStorage.setItem("i18nextLng", prev);
    }
  };

  const display = current === "en" ? "Fr" : "En";

  return (
    <div>
      <span onClick={switchLanguage} style={{ cursor: "pointer",marginRight:'15px', padding: "4px 8px", border: "1px solid var(--nav-stroke)", borderRadius: "4px", fontSize: "1.3rem" }} aria-label={i18n.t('Switch language')}>
        {display}
      </span>
    </div>
  );
}
